import React, { Fragment, useState } from "react";
import { CircularProgress, Divider } from "@mui/material";
import { useSelector } from "react-redux";
import moment from "moment";
import { CentralModal } from "../CentralModal/CentralModal";
import { getSurgeryCallDetailsService } from "../../../_services";
import "./centralSurgeryCallDetailsModal.css";

export const CentralSurgeryCallDetailsModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [surgeryDetails, setSurgeryDetails] = useState([])
  const [isEmptyModal, setIsEmptyModal] = useState(false)
  const reportingData = useSelector(state=>state.centralReportingData?.reportingData);
  const appointmentId = reportingData.data[0].appointment_id || reportingData.data[0]._id;

  const handleTimeStamp = (value) => {
    try {
      if (!moment(value).isValid()) {
        return '--'
      }
      return moment(value).format("DD MMM, hh:mm A");
    } catch (error) {
      return "--";
    }
  };

  const getSurgeryData = () =>{
      if(appointmentId){
          setIsEmptyModal(true)
          getSurgeryCallDetailsService(appointmentId)
          .then(res=>{
              if(res.status==='Success' && res.result?.length > 0){
                setSurgeryDetails(res.result)
            }
          })
          .catch(error=>console.log('Surgery call details fetching error', error))
          .finally(()=>{
            setIsEmptyModal(false)
          })
      }
  }
  
  const handleModalOpen = () => {
    getSurgeryData()
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const renderModalData = () =>{
        return(
            <>
            {surgeryDetails.map(item=><Fragment key={item.id}>
                <div className="textReadOnlyRow">
                    <span className="textReadOnlyLabel">Status</span>
                    <span className="textReadOnlyValue" style={{color:item.surgeryStatus?.toLowerCase() ==='not ok for surgery' ? 'red' : '#393939'}}>{item.surgeryStatus || '--' }</span>
                </div>
                <div className="textReadOnlyRow">
                    <span className="textReadOnlyLabel">Reason</span>
                    <span className="textReadOnlyValue">{ item.reason || '--' }</span>
                </div>
                <div className="textReadOnlyRow">
                    <span className="textReadOnlyLabel">Remarks</span>
                    <span className="textReadOnlyValue">{ item.remarks || '--'}</span>
                </div>
                <div className="textReadOnlyRow">
                    <span className="textReadOnlyLabel">Updated At</span>
                    <span className="textReadOnlyValue">{item?.createdAt ? handleTimeStamp(item._created_at) :'--' }</span>
                </div>
                <div className="textReadOnlyRow">
                    <span className="textReadOnlyLabel">Updated By</span>
                    <span className="textReadOnlyValue">{ item.updatedBy || '--' }</span>
                </div>
                <Divider sx={{mb:'10px'}}/>
            </Fragment>)}
            </>
        )
  }

  return (
    <div className="textReadOnlyRow">
      <span className="textReadOnlyLabel">Surgery Call Details</span>
      <CentralModal
        open={isModalOpen}
        onClose={handleModalClose}
        modalTitle={"Surgery Call Details"}
        sx={{ minHeight: "155px" }}
        modalButton={
          <div className="defaultModalButton" onClick={handleModalOpen}>
            View
          </div>
        }
      >
        {isEmptyModal?<div className="summaryModalLoader">
            <CircularProgress fontSize="small" />
          </div>
          : 
          surgeryDetails.length===0 ? <div className="noDataFoundText">No Data Found</div>:
           renderModalData()}
      </CentralModal>
    </div>
  );
};
